import { render, staticRenderFns } from "./NoTactics.vue?vue&type=template&id=5d0ea8db&scoped=true&"
import script from "./NoTactics.vue?vue&type=script&lang=js&"
export * from "./NoTactics.vue?vue&type=script&lang=js&"
import style0 from "./NoTactics.vue?vue&type=style&index=0&id=5d0ea8db&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0ea8db",
  null
  
)

export default component.exports